import * as api from './api'
import * as exportFile from './exportFile'
import AuthService from './auth'
import { msalApp } from '../utils/auth'

const auth =  new AuthService(msalApp)
export const services = { auth, api, exportFile }
